import React from 'react';

import { Tabs, TabsContent } from '@/components/ui/tabs';
import useMatterSelection from '@/hooks/useMatterSelection';

import { DomainEventsFeed } from '../domain-events-v2';
import { TaskPanel } from '../task-panel';

interface ActivityPanelProps {
  activeTab: 'tasks' | 'activity';
  onOpenCreateTask: () => void;
  /** Ref that will be populated with TaskDetail's internal handleStatusChange handler */
  onStatusChangeRef?: React.MutableRefObject<((status: { id: string; canonical_status: string }) => void) | null>;
  /** Search term for task filtering (managed by parent) */
  searchTerm?: string;
  onSearchTermChange?: (value: string) => void;
}

export const ActivityPanel: React.FC<ActivityPanelProps> = ({
  activeTab,
  onOpenCreateTask,
  onStatusChangeRef,
  searchTerm,
  onSearchTermChange,
}) => {
  const { selectedMatterData } = useMatterSelection();

  if (!selectedMatterData) {
    return null;
  }

  return (
    <div className="h-full flex flex-col">
      <Tabs value={activeTab} className="h-full flex flex-col">
        <TabsContent
          value="tasks"
          className="flex-1 overflow-hidden data-[state=inactive]:hidden"
        >
          <TaskPanel onOpenCreateTask={onOpenCreateTask} onStatusChangeRef={onStatusChangeRef} searchTerm={searchTerm} onSearchTermChange={onSearchTermChange} />
        </TabsContent>

        <TabsContent
          value="activity"
          className="flex-1 overflow-hidden data-[state=inactive]:hidden"
        >
          <DomainEventsFeed matterId={selectedMatterData.id} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
